import React, { useState } from 'react'
import * as S from './style';
import Image from '../../loggedout/common/Image';
import { getCDNAssetURL } from '../../../utils/web-helper';
const cdnAssetUrl = getCDNAssetURL();
const infoIcon = `${cdnAssetUrl}/assets/icons/info_icon_hollow.svg`;
const crossIcon = `${cdnAssetUrl}/assets/icons/cross_icon.svg`;

const ErrorToast = ({ msg, onToastHidden }) => {
  const [hideToast, setHideToast] = useState(false);
  const errorMsg = msg || "Something went wrong! Please try again."

  const crossClickHandler = () => {
    setHideToast(true);
    typeof onToastHidden === "function" && onToastHidden();
  }

  if (!hideToast) {
    return(
    <S.Container>
      <S.InfoIcon>
        <Image src={infoIcon} isCdnImage={true} />
      </S.InfoIcon>
      <S.ErrorText>{errorMsg}</S.ErrorText>
      <S.Cross data-testid="cross-btn" onClick={crossClickHandler}>
        <Image src={crossIcon} isCdnImage={true}/>
      </S.Cross>
    </S.Container>)
  }
  return null;
}

export default ErrorToast